module.exports = __webpack_public_path__ + "static/media/sandee_good.aeae21ce.png";